<template>
  <div class="leave">
    <van-nav-bar right-text="申请代接送" @click-right="clickNavBarRight">
    </van-nav-bar>
    <div class="leave-list-wrap">
      <!-- <div class="leave-list-title">代接送列表</div> -->
      <div class="leave-list" v-if="list.length > 0">
        <div
          class="leave-list-item"
          v-for="item in list"
          :key="item.id"
          @click="clickLeaveDetail(item)"
        >
          <div class="cause flex flex-b flex-vc">
            <span>姓名：{{ item.pickUpPerson }}</span>
            <!-- <span class="status">{{ item.leaveState }}</span> -->
            <van-tag plain type="success" v-if="item.pickUpState == 1"
              >已同意</van-tag
            >
            <van-tag plain type="primary" v-if="item.pickUpState == 0"
              >待审批</van-tag
            >
            <van-tag plain type="danger" v-if="item.pickUpState == -1"
              >已拒绝</van-tag
            >
          </div>
          <div class="date">
            <span>开始时间：</span
            ><span>{{ getDateYMD(item.pickBeginTime) }}</span>
          </div>
          <div class="date">
            <span>结束时间：</span
            ><span>{{ getDateYMD(item.pickEndTime) }}</span>
          </div>
          <div class="date">
            <span
              style="width: 3.7rem; display: inline-block; text-align: right;"
              >原因：</span
            ><span>{{ item.reason }}</span>
          </div>
        </div>
      </div>
      <div class="" v-if="list.length <= 0">
        <van-empty description="暂无数据" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { compare, getDateYMD, timeFormart } from '@/utils'

export default {
  data() {
    return {
      list: [
        // {
        //   name: '王源',
        //   leaveState: 0,
        //   remark: '优势老不老',
        // },
      ],
    }
  },
  mounted() {
    Promise.all([
      this.getPickupList(0),
      this.getPickupList(1),
      this.getPickupList(-1),
      this.getPickupList(-2),
    ]).then((res) => {
      res.forEach((item) => {
        item.list.forEach((v) => {
          this.list.push(v)
        })
      })
    })
  },
  methods: {
    getDateYMD,
    clickBack() {
      this.$router.go(-1)
    },
    clickNavBarRight() {
      this.$router.push('/pickupForm')
    },
    clickLeaveDetail(item) {
      this.$router.push({
        path: '/pickupDetail',
        query: { id: item.id, type: 'list' },
      })
    },
    async getPickupList(state) {
      const { data, code } = await this.$https.pickupList({
        pickUpState: state,
        userId: this.$store.state.puserId,
        schoolId: this.$store.state.pschoolId,
      })
      if (code !== 200) {
        this.$toast('获取代接送列表失败')
        return false
      }
      return Promise.resolve(data)
    },

    renderTime(StatusMinute) {
      var day = parseInt(StatusMinute / 60 / 24)
      var hour = parseInt((StatusMinute / 60) % 24)
      var min = parseInt(StatusMinute % 60)
      StatusMinute = ''
      if (day > 0) {
        StatusMinute = day + '天'
      }
      if (hour > 0) {
        StatusMinute += hour + '小时'
      }
      if (min > 0) {
        StatusMinute += parseFloat(min) + '分钟'
      }
      return `（共计${StatusMinute}）`
    },
  },
}
</script>

<style lang="scss" scoped>
.leave-list-wrap {
  .leave-list-title {
    padding: 1rem;
  }
  .leave-list {
    border-radius: 0.75rem;
    border-radius: 1.0625rem;
    margin: 0.5rem;
    box-shadow: 0rem 1rem 1rem rgba(69, 91, 99, 0.1);
    overflow: hidden;
    .leave-list-item {
      display: flex;
      flex-direction: column;
      padding: 0.75rem;

      background: #fff;
      font-size: 0.75rem;
      color: rgba(120, 132, 158, 1);
      border-bottom: 1px solid #f4f4f6;

      .cause {
        font-size: 1rem;
        font-weight: bold;
        color: #333;
        margin-bottom: 0.55rem;
        .status {
          color: #1989fa;
          font-size: 0.85rem;
        }
      }
      .date {
        margin-bottom: 0.55rem;
      }
    }
  }
}
</style>
